import React from 'react';
import { Container, Row, Col, Card, Spinner, Alert } from "react-bootstrap";
import { InicioCode } from "./Inicio.Code";
import ReactApexChart from "react-apexcharts";
import moment from 'moment';

const InicioView = () => {
  const { loading, dashboardData, erroApi, tema } = InicioCode();

  return (
    <Container className="pb-5 pt-4">
      <div className="mb-4">
        <h4 className="fw-bold m-0">Dashboard Inicial</h4>
        <small className="text-body-secondary">Resumo da competência: {moment().format('MM/YYYY')}</small>
      </div>

      {loading ? (
        <div className="d-flex justify-content-center align-items-center mt-5">
          <Spinner animation="border" variant="primary" />
        </div>
      ) : erroApi ? (
        <Alert variant="danger" className="mt-4 text-center">
          Ocorreu uma falha na API fiscal. Não foi possível carregar o dashboard. Tente novamente mais tarde.
        </Alert>
      ) : dashboardData ? (
        <>
          <Row className="mb-4 g-3">
            <Col xs={12} sm={6} lg={3}>
              <Card className="shadow-sm border-0 h-100">
                <Card.Body className="d-flex flex-column justify-content-center align-items-center text-center">
                  <h6 className="text-body-secondary text-uppercase mb-2" style={{ fontSize: '0.8rem' }}>Faturamento Total</h6>
                  <h4 className="text-primary fw-bold mb-0">
                    {dashboardData.totalFaturamento.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                  </h4>
                </Card.Body>
              </Card>
            </Col>

            <Col xs={12} sm={6} lg={3}>
              <Card className="shadow-sm border-0 h-100">
                <Card.Body className="d-flex flex-column justify-content-center align-items-center text-center">
                  <h6 className="text-body-secondary text-uppercase mb-2" style={{ fontSize: '0.8rem' }}>Total Emitidas</h6>
                  <h4 className="fw-bold mb-0">
                    {dashboardData.totalNotas}
                  </h4>
                </Card.Body>
              </Card>
            </Col>

            <Col xs={12} sm={6} lg={3}>
              <Card className="shadow-sm border-0 h-100">
                <Card.Body className="d-flex flex-column justify-content-center align-items-center text-center">
                  <h6 className="text-body-secondary text-uppercase mb-2" style={{ fontSize: '0.8rem' }}>Total NFe</h6>
                  <h4 className="text-info fw-bold mb-0">
                    {dashboardData.totalNFe}
                  </h4>
                </Card.Body>
              </Card>
            </Col>

            <Col xs={12} sm={6} lg={3}>
              <Card className="shadow-sm border-0 h-100">
                <Card.Body className="d-flex flex-column justify-content-center align-items-center text-center">
                  <h6 className="text-body-secondary text-uppercase mb-2" style={{ fontSize: '0.8rem' }}>Total NFCe</h6>
                  <h4 className="text-success fw-bold mb-0">
                    {dashboardData.totalNFCe}
                  </h4>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          <Row>
            <Col xs={12}>
              <Card className="shadow-sm border-0">
                <Card.Body>
                  <Card.Title className="text-body-secondary mb-4">Evolução de Faturamento Diário (R$)</Card.Title>
                  <ReactApexChart
                    key={tema}
                    options={dashboardData.chartOptions}
                    series={dashboardData.chartSeries}
                    type="area"
                    height={350}
                  />
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </>
      ) : (
        <div className="text-center mt-5">
          <h5 className="text-body-secondary">Nenhum dado encontrado para o dashboard.</h5>
        </div>
      )}
    </Container>
  );
};

export default InicioView;
